import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/EditOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class InfoDialog extends React.Component {
  field(label, value) {
    const { classes } = this.props;

    if (value) {
      return (
        <div className={classes.field}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography>{value}</Typography>
        </div>
      );
    }
  }

  render() {
    const {
      classes,
      open,
      cancel,
      confirm,
      mobile,
      mobileName,
      phone,
      phoneName,
      email,
      emergencyName,
      emergencyPhone,
      dialogText,
      fields,
      submitLabel,
      cancelLabel,
    } = this.props;

    const stringsComponent = 'contactDetails';

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          content={
            <React.Fragment>
              <Typography className={classes.dialogText}>
                {dialogText}
              </Typography>
              <div className={classes.changes}>
                {this.field(
                  getString(stringsComponent, 'MOBILE_LABEL'),
                  mobile
                )}
                {this.field(
                  getString(stringsComponent, 'MOBILE_NAME_LABEL'),
                  mobileName
                )}
                {this.field(getString(stringsComponent, 'PHONE_LABEL'), phone)}
                {this.field(
                  getString(stringsComponent, 'PHONE_NAME_LABEL'),
                  phoneName
                )}
                {this.field(getString(stringsComponent, 'EMAIL_LABEL'), email)}
                {emergencyName || emergencyPhone ? (
                  <Typography className={classes.subheading}>
                    {getString(stringsComponent, 'EMERGENCY_CONTACT_TITLE')}
                  </Typography>
                ) : (
                  ''
                )}
                {this.field(
                  getString(stringsComponent, 'PHONE_LABEL'),
                  emergencyPhone
                )}

                {this.field(
                  getString(stringsComponent, 'NAME_LABEL'),
                  emergencyName
                )}
                {fields.length
                  ? fields.map((field, i) => {
                      return (
                        <React.Fragment key={i}>
                          {this.field(field.label, field.value)}
                        </React.Fragment>
                      );
                    })
                  : ''}
              </div>
            </React.Fragment>
          }
          contentWrap={false}
          title={getString(stringsComponent, 'CONFIRM_TITLE')}
          buttonAction={confirm}
          buttonLabel={
            submitLabel
              ? submitLabel
              : getString(stringsComponent, 'SUBMIT_BUTTON_LABEL')
          }
          secondaryButtonAction={cancel}
          secondaryButtonLabel={
            cancelLabel
              ? cancelLabel
              : getString(stringsComponent, 'CANCEL_BUTTON_LABEL')
          }
          icon={EditIcon}
        />
      </div>
    );
  }
}

InfoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  mobile: PropTypes.string,
  mobileName: PropTypes.string,
  phone: PropTypes.string,
  phoneName: PropTypes.string,
  email: PropTypes.string,
  contact1Name: PropTypes.string,
  contact1Phone: PropTypes.string,
  contact2Name: PropTypes.string,
  contact2Phone: PropTypes.string,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  dialogText: PropTypes.string,
};

InfoDialog.defaultProps = {
  open: false,
  fields: [],
  dialogText: '',
};

export default withStyles(styles)(InfoDialog);
